import Box from '@eduzz/houston-ui/Box';
import Column from '@eduzz/houston-ui/Grid/Column';
import Row from '@eduzz/houston-ui/Grid/Row';
import { Button, TextField, InputAdornment, Icon, Hidden, Collapse, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Link } from 'react-router-dom';

import PermissionHide from '../PermissionHide/index';

const useStyles = makeStyles(() => ({
  footer: {
    minWidth: '100%',
    margin: 'auto',
    letterSpacing: 0,
  },
  input: {
    background: 'transparent !important',
  },
  title: {
    fontWeight: 500,
    fontSize: 21,
    opacity: 0.5,
    marginBottom: 20,
  },
  submit: {
    marginTop: 12,
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
  },
  toggleButton: {
    textAlign: 'center',
    opacity: 0.1,
    paddingTop: 24,
  },
  link: {
    marginTop: 12,
    textDecoration: 'underline',
    display: 'block',
    color: 'rgba(0,0,0,.7)',
    fontSize: 14,
  },
  box: {
    border: '1px solid #ddd',
  },
  text: {
    fontSize: 13,
    textAlign: 'center',
    opacity: 0.5,
    textTransform: 'uppercase',
    padding: '1rem',
  },
}));

const Footer = () => {
  const classes = useStyles();
  const [show, toggle] = React.useState(false);

  const onClick = () => {
    toggle(!show);
    localStorage.setItem('helper-footer', `${!show}`);
  };

  return (
    <footer id='main-footer' className={classes.footer}>
      <div className={classes.container}>
        <Tooltip title='Ajuda Rápida'>
          <Button className={classes.toggleButton}>
            <svg onClick={onClick} xmlns='http://www.w3.org/2000/svg' width='44' height='44' fill='currentColor' viewBox='0 0 16 16'>
              {show && (
                <path fillRule='evenodd' d='M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894l6-3z' />
              )}
              {!show && (
                <>
                  <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
                  <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
                  <path d='M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z' />
                </>
              )}
            </svg>
          </Button>
        </Tooltip>
      </div>

      <Collapse in={show}>
        <Box className={classes.box} xs={{ padding: 24 }}>
          <Row>
            <Column xs={12} sm={6}>
              <h4>Ajuda rápida com artigos e tutoriais</h4>
              <small>Descubra como fazer qualquer coisa na Eduzz.</small>
              <Hidden smDown>
                <PermissionHide action={'myeduzz:ajuda:visualizar'}>
                  <Link className={classes.link} to='/producer/help'>
                    Ir para Central de Ajuda
                  </Link>
                </PermissionHide>
              </Hidden>
            </Column>
            <Column xs={12} sm={6}>
              <form action='https://ajuda.eduzz.com/hc/pt-br/search' method='GET' target='_blank'>
                <input type='hidden' name='utm_source' value='myeduzz_footer' />
                <input type='hidden' name='utf8' value='✓' />
                <TextField
                  fullWidth
                  className={classes.input}
                  name='query'
                  type='search'
                  placeholder='como criar um produto físico'
                  InputProps={{
                    disableUnderline: true,
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Icon>search</Icon>
                      </InputAdornment>
                    ),
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Button className={classes.submit} size='small' type='submit' variant='contained' disableElevation>
                  Pesquisar
                </Button>
              </form>
            </Column>
          </Row>
        </Box>
      </Collapse>
      <p className={classes.text}>{new Date().getFullYear()} © Eduzz – Todos os Direitos Reservados</p>
    </footer>
  );
};

export default Footer;
